/**
 * ShopDeleteProductDialog - Product deletion confirmation dialog
 * Extracted from AdminShopTab.js in Phase 4D-8
 * 
 * Purpose:
 * - Confirm before deleting a product
 * - Display product title for clarity
 * - Warn that action cannot be undone
 */
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../ui/alert-dialog';

/**
 * @param {Object} props
 * @param {boolean} props.open - Whether dialog is open
 * @param {Function} props.onOpenChange - Callback when open state changes
 * @param {Object|null} props.product - Product to delete
 * @param {string} props.product.title - Product title for display
 * @param {Function} props.onConfirm - Callback when delete confirmed
 */
export function ShopDeleteProductDialog({
  open,
  onOpenChange,
  product,
  onConfirm
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Product?</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete &quot;{product?.title}&quot;? This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-red-600 hover:bg-red-700"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default ShopDeleteProductDialog;
